<template>
  <form>
    <input type="hidden" name="_token" :value="csrfToken" />
    <input type="hidden" name="message_index" value="1" />
    <div class="l-page l-page--message-edit-condition">
      <main class="l-main">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" />
        <!-- /パンくずリスト -->

        <div class="l-main-head">
          <div class="c-title u-w420">
            <h2 class="c-title__text c-title__text--blue u-fs34">シナリオの新規作成</h2>
          </div>
          <div class="c-progress c-progress--step-message">
            <ul class="c-progress-list">
              <li class="c-progress-list__item is-current">シナリオ名の作成<br />配信条件設定</li>
              <li class="c-progress-list__item">メッセージの作成</li>
              <li class="c-progress-list__item">トリガー設定と<br />追加配信メッセージの作成</li>
              <li class="c-progress-list__item">配信内容の<br />確認</li>
              <li class="c-progress-list__item">設定完了</li>
            </ul>
          </div>
        </div>

        <div class="l-main-content">
          <div class="p-message-edit p-message-edit--delivery-segment-group">
            <div class="c-title">
              <div class="c-title__text u-fs24">シナリオ名を登録する</div>
            </div>
            <div class="p-message-edit-list p-message-edit-list--first">
              <div class="p-message-edit-list__item">
                <div class="c-input u-w450">
                  <input
                    v-model="scenarioName"
                    class="c-input__item"
                    type="text"
                    name="scenario_name"
                    value=""
                    placeholder="シナリオ配信の管理名を入力してください"
                  />
                  <div class="c-error c-error--balloon c-error--group-name">
                    <div class="c-error__text"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="l-main-content">
          <div class="p-message-edit p-message-edit--delivery-segment-group">
            <div class="c-title">
              <div class="c-title__text u-fs24">配信条件を選ぶ</div>
            </div>
            <div class="p-message-edit-list p-message-edit-list--first">
              <div class="p-message-edit-list__item">
                <div class="c-select-card">
                  <ul class="c-select-card-list">
                    <li class="c-select-card-list__item">
                      <label class="c-select-card__label">
                        <input
                          v-model="conditionType"
                          type="radio"
                          name="delivery_condition_type"
                          value="1"
                        />
                        <div class="c-select-card__item">
                          <div class="c-icon-circle c-icon-circle--purple u-wh80">
                            <div class="c-icon-circle__item c-icon-circle__item--white u-wh44">
                              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <use xlink:href="/assets/img/sprite.svg#segment-user" />
                              </svg>
                            </div>
                          </div>
                          <div class="c-select-card-content">
                            <div class="c-select-card-content__title">セグメント配信</div>
                            <div class="c-select-card-content__text">指定ページへの訪問ユーザーや端末・OSなど</div>
                            <div class="c-select-card-content__text">絞りこんだ配信を行います</div>
                          </div>
                        </div>
                      </label>
                    </li>
                    <li class="c-select-card-list__item">
                      <label class="c-select-card__label">
                        <input
                          v-model="conditionType"
                          type="radio"
                          name="delivery_condition_type"
                          value="2"
                        />
                        <div class="c-select-card__item">
                          <div class="c-icon-circle c-icon-circle--orange u-wh80">
                            <div class="c-icon-circle__item c-icon-circle__item--white u-wh44">
                              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <use xlink:href="/assets/img/sprite.svg#all-user" />
                              </svg>
                            </div>
                          </div>
                          <div class="c-select-card-content">
                            <div class="c-select-card-content__title">
                              全配信<span class="c-select-card-content__title--recommended">始めたばかりの方におすすめ！</span>
                            </div>
                            <div class="c-select-card-content__text">すべてのオプトインに配信を行います</div>
                          </div>
                        </div>
                      </label>
                    </li>
                  </ul>
                  <div class="c-error c-error--balloon">
                    <div class="c-error__text"></div>
                  </div>
                </div>
              </div>
              <div v-show="conditionType != 2" class="p-message-edit-condition-select-block">
                <div class="c-title">
                  <div class="c-title__text">セグメントの接続タイプ</div>
                </div>
                <div class="p-message-edit-list__item">
                  <div class="c-radio u-w100p">
                    <ul class="c-radio-list">
                      <li class="c-radio-list__item">
                        <label class="c-radio__label u-w300">
                          <input
                            v-model="conditionJoinType"
                            type="radio"
                            name="condition_join_type"
                            value="AND"
                          />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">かつ(AND) </div>
                          </div>
                        </label>
                      </li>
                      <li class="c-radio-list__item u-w300">
                        <label class="c-radio__label">
                          <input
                            v-model="conditionJoinType"
                            type="radio"
                            name="condition_join_type"
                            value="OR"
                          />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">または(OR)</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-radio-list__item u-w300">
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <message-select-condition
                v-show="conditionType != 2"
                ref="messageSelectCondition"
                :is-enable-topic-condition="isEnableTopicCondition"
                :width="456"
                :base-conditions="conditionInfo.conditions"
                :base-condition-source-types="conditionInfo.conditionSourceTypes"
                :topic-conditions="conditionInfo.topicConditions"
                :on-select="onSelectConditionChange"
                :initial-data="{ baseConditions: messageConditionData.conditions, topicConditions: messageConditionData.topicConditions }"
              />
            </div>
          </div>
        </div>
      </main>
    </div>
    <div class="p-message-predict p-message-predict--no-number">
      <div class="p-message-predict__content">
        <div class="p-message-predict-suspend">
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w146 u-fs24"
              type="button"
              name="destroy"
              value="destroy"
              @click="onCancelClick($event)"
            >
              <p class="c-btn__text">作成をやめる</p>
            </button>
          </div>
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w96 u-fs24"
              type="button"
              name="save"
              value="save"
              @click="onSaveClick($event)"
            >
              <p class="c-btn__text">保存する</p>
            </button>
          </div>
        </div>
        <div class="p-message-predict__btns">
          <button
            class="c-btn c-btn--blue u-w320 u-h50 u-fs20"
            type="button"
            name="next"
            value="next"
            :class="{ 'is-loading': isLoadingConfirmBtn }"
            :disabled="isLoadingConfirmBtn"
            @click="onAddMessageClick($event)"
          >
            <p class="c-btn__text">メッセージの作成へ進む</p>
          </button>
        </div>
      </div>
    </div>
    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />

  </form>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    isEnableTopicCondition: Boolean,
    linkData: Object,
    csrfToken: String,
    breadcrumbData: Array,
    scenario: Object,
    conditionInfo: Object,
  },
  data () {
    return {
      scenarioId: null,
      scenarioName: null,
      conditionType: null,
      isSegment: false,
      createType: null,
      selectedConditionId: null,
      selectedTopicConditionId: null,
      isLoading: false,
      conditionName: null,
      conditionDetailList: [],
      conditionDetailKey: null,
      conditionJoinType: (this.scenario) ? this.scenario.condition_join_type : 'AND',
      genders: [],
      ages: [],
      regions: [],
      interest: null,
      keyword: null,
      allValue: '9999',
      conditionId: null,
      conditionIds: null,
      topicConditionId: null,
      topicConditionIds: null,
      errorMessage: '',
      isError: false,
      isLoadingConfirmBtn: false,
      params: {
        conditions: [],
        topicConditions: [],
      },
    }
  },
  computed: {
    // 選択済み配信条件の取得
    messageConditionData: function () {
      // 返り値配列の初期化
      const data = {
        conditions: [],
        topicConditions: [],
      }

      // シナリオ配信データが存在し、1つめのメッセージが存在する場合
      if (this.scenario && this.scenario.scenario_messages && this.scenario.scenario_messages.length > 0) {
        const message = this.scenario.scenario_messages[0].message;
        data.conditions = message.message_conditions && Array.isArray(message.message_conditions) && message.message_conditions.length > 0
          ? message.message_conditions : []
        data.topicConditions = message.topic_message_condition
          ? [message.topic_message_condition] : []
      }

      // 抽出した配信条件を返却
      return data
    }
  },
  mounted: function() {
    import('../../funcs/pages/message-add-condition').then(module => {
      module.MessageAddCondition();
    });
    import('../../funcs/components/select').then(module => {
      module.Select();
    });

    this.conditionDetailList = [];

    // 各KeyのConditionDetailを１個ずつ作成しておく
    // Object.keys(this.conditionInfo.conditionKeyTypes).map(conditionKey => {
    //     this.conditionDetailList[conditionKey] = [];
    //     this.conditionDetailList[conditionKey].push({
    //         value: '',
    //         operator: 'eq'
    //     });
    // });

    if(this.scenario){
      this.scenarioId = this.scenario.scenario_id;
      this.scenarioName = this.scenario.scenario_name;
      if(this.scenario.scenario_messages && this.scenario.scenario_messages.length > 0){
        let message = this.scenario.scenario_messages[0].message;

        //
        // @TODO 属性条件も複数設定可能になるとの事だったので、message.topic_message_conditionがmessage.topic_message_conditionsの複数形キーで返ってくるようになるか確認
        //
        if (
          (message.message_conditions && Array.isArray(message.message_conditions) && message.message_conditions.length > 0) ||
          (message.topic_message_condition /* && Array.isArray(topic_message.message_condition) && message.topic_message_condition.length > 0*/)
        ) {
          this.conditionType = 1;
          this.params = {
            conditions: (message.message_conditions && Array.isArray(message.message_conditions) && message.message_conditions.length > 0)
              ? message.message_conditions.map((item) => item.condition_id)
              : [],
            topicConditions: message.topic_message_condition
              ? [message.topic_message_condition.topiic_condition_id]
              : [],
          }
        } else {
          this.conditionType = 2;
        }

        //
        // 複数配信条件 && 基本条件 && 属性条件がOKになるので、コメントアウト
        // if (message.message_conditions && (message.message_conditions.length > 0)) {
        //     this.conditionType = 1;
        //     let conditionId = message.message_conditions[0].condition_id;
        //     //this.selectedConditionId = conditionId;
        //     // this.$refs.conditionSelect.setValue(conditionId);
        //     // this.loadCondition(conditionId);
        //     this.createType = 2; // 既存指定
        //     this.isSegment = false;
        // } else if(message.topic_message_condition){
        //     this.conditionType = 1;
        //     let topicConditionId = message.topic_message_condition.topic_condition_id;
        //     this.selectedTopicConditionId = topicConditionId;
        //     // this.$refs.topicConditionSelect.setValue(topicConditionId);
        //     // this.loadTopicCondition(topicConditionId);
        //     this.createType = 3; // 既存指定
        //     this.isSegment = true;
        // } else {
        //     this.conditionType = 2;
        // }
      }
    }
  },
  methods: {
    onCancelClick: function(event) {
      event.preventDefault();
      location.href = '/coins-admin/step';
    },
    onSaveClick: function(_event) {
      // event.preventDefault();
      // this.$refs.form.action = this.linkData.saveUrl;
      // this.$refs.form.submit();
      this.saveScenario((_) => {
        location.href = '/coins-admin/step';
      });
    },
    appendForm(params,name,value){
      // null/undefinedの場合のみスキップ、空文字列や0は送信する
      if(value !== null && value !== undefined){
        params.append(name,value);
      }
    },
    onQuitClick: function () {
      location.href = this.conditionInfo.listUrl;
    },
    onBackClick: function () {
      location.href = this.conditionInfo.editUrl + '?type=edit&message_id=' + this.message.message_id;
    },
    saveScenario: function(callback) {
      // シナリオデータ作成用のパラメーター作成
      let params = new FormData();
      this.appendForm(params,'scenario_id',this.scenarioId);
      this.appendForm(params,'scenario_name',this.scenarioName);
      this.appendForm(params,'condition_ids',this.params.conditions);
      this.appendForm(params,'topic_condition_ids',
                      // 属性条件はDMP連携している時のみ設定値を送信
                      this.isEnableTopicCondition ? this.params.topicConditions : null
      );

      // 保存リクエスト実行
      axios.post('/api/scenario/save', params)
        .then(res => {
          if (this.handleResponse(res)) {
            let scenarioId = res.data.scenario_id;
            let conditionIds = (res.data.condition_ids) ? res.data.condition_ids : [];
            let topicConditionIds = (res.data.topic_condition_ids) ? res.data.topic_condition_ids : [];

            //
            // @TODO
            // resに入ってくる属性条件のキーが、topic_condition_idになっている。
            // 複数対応したら、キーが変わるのか？確認する
            //
            const queryParameter = {
              conditions: (0 < conditionIds.length)
                ? `condition_ids[]=${conditionIds.join('&condition_ids[]=')}`
                : '',
              // 属性条件が有効ではない場合は、仮に選択値があっても使用しない
              topicConditions: (0 < topicConditionIds.length && this.isEnableTopicCondition)
                ? `topic_condition_ids[]=${topicConditionIds.join('&topic_condition_ids[]=')}`
                : '',
            }

            // 遷移先URLを作成
            let url = new URL(
              this.conditionInfo.addMessageUrl +
                '?scenario_id=' + scenarioId +
                '&step_no=1' +
                '&condition_join_type=' + this.conditionJoinType +
                (queryParameter.conditions != '' ? `&${queryParameter.conditions}` : '') +
                (queryParameter.topicConditions != '' ? `&${queryParameter.topicConditions}` : '')

            );
            callback(url);

          } else {
            this.isError = true;
            this.errorMessage = (res && res.data && res.data.message)
              ? res.data.message
              : 'シナリオの保存に失敗しました';
          }

          setTimeout(() => {
            this.isLoadingConfirmBtn = false;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'シナリオの保存に失敗しました';
          setTimeout(() => {
            this.isLoadingConfirmBtn = false;
          }, 300);
        });
    },

    // 保存処理: メッセージの作為へ進む
    onAddMessageClick: function () {
      // -------------------------------------
      // [1]. 入力値検証
      // -------------------------------------
      // エラーメッセージオブジェクト初期化
      const inputErrorMessages = {}

      // 入力値検証: シナリオ配信名
      if (!this.scenarioName || this.scenarioName == '') {
        inputErrorMessages.scenario_name = 'シナリオ配信の管理名を入力してください'
      }

      // 入力値検証: 配信条件
      if (this.conditionType != 1 && this.conditionType != 2) {
        inputErrorMessages.delivery_condition_type = '配信条件を選択してください'
      }

      // 入力値検証: 配信条件
      if (this.conditionType == 1 && this.params.conditions.length < 1 && this.params.topicConditions.length < 1) {
        // ※ 子コンポーネントでエラーメッセージは管理されているので、使用されないが、エラーがあったか？の判定用に追加
        inputErrorMessages.selectCondition = '1つ以上の配信条件を選択してください'
        this.$refs.messageSelectCondition.setErrorBaseCondition('1つ以上の配信条件を選択してください')
        this.$refs.messageSelectCondition.setErrorTopicCondition('1つ以上の配信条件を選択してください')
      }

      // 入力エラーが１件でも存在する場合は、エラーを表示して処理終了
      if (Object.keys(inputErrorMessages).length > 0) {
        // 部品単位のエラーメッセージ表示
        this.showErrors(inputErrorMessages);

        // エラーモーダル表示
        this.isError = true;
        this.errorMessage = '入力内容に誤りがあります';
        return;
      }


      // -------------------------------------
      // [2]. メッセージ保存処理
      // -------------------------------------
      // ローディング表示設定・ボタン無効化
      this.isLoadingConfirmBtn = true;

      // 全配信が選択された場合は、配信条件をクリア
      if (this.conditionType == 2) {
        this.params.conditions = [];
        this.params.topicConditions = [];
      }

      // シナリオデータの保存処理実行
      this.saveScenario((url) => {
        location.href = url;
      });
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    onSelectConditionChange: function(baseConditions, topicConditions) {
      this.params.conditions = baseConditions
        .filter((item) => item.id)
        .map((item) => item.id);
      this.params.topicConditions = topicConditions
        .filter((item) => item.id)
        .map((item) => item.id);
    }
  }
}
</script>
